import Link from 'next/link';
import { PAYWALL_LINKS } from '@/features/tool/constants/paywall';

const Paywall3LegalText = ({
  trialSegment,
  dueTodayAmountText,
  recurringAmountText,
  recurringPeriodText,
  recurringAdjective,
}: {
  trialSegment: string;
  dueTodayAmountText: string;
  recurringAmountText: string;
  recurringPeriodText: string;
  recurringAdjective: string;
}) => (
  <p className="text-[14px] leading-5 text-[#292A33]">
    By continuing, you agree that you will be charged{' '}
    <strong className="font-semibold">{dueTodayAmountText}</strong>{' '}
    {trialSegment ? (
      <>
        today for a {trialSegment} trial and{' '}
        <strong className="font-semibold">{recurringAmountText}</strong>{' '}
        automatically{' '}
        <strong className="font-semibold">every {recurringPeriodText}</strong>{' '}
        thereafter unless you cancel before your trial ends.
      </>
    ) : (
      <>
        today and automatically{' '}
        <strong className="font-semibold">every {recurringPeriodText}</strong>{' '}
        unless you cancel.
      </>
    )}{' '}
    You can cancel your auto-renewing subscription through your online account
    before your next {recurringAdjective} renewal date. You also agree to our{' '}
    <Link
      href={PAYWALL_LINKS.subscription}
      target="_blank"
      className="font-semibold"
    >
      Subscription Policy
    </Link>{' '}
    and{' '}
    <Link href={PAYWALL_LINKS.refund} target="_blank" className="font-semibold">
      Refund Policy
    </Link>
    .
  </p>
);

export default Paywall3LegalText;
